export const dateRangeToBounds = (range) => {
    if (range === "All Time") return { startDate: null, endDate: null };
    const end = new Date();
    const start = new Date();
    if (range === "Last 7 Days") start.setDate(end.getDate() - 7);
    else if (range === "Last 30 Days") start.setDate(end.getDate() - 30);
    else if (range === "Last 90 Days") start.setDate(end.getDate() - 90);
    else if (range === "This Year") {
        start.setMonth(0, 1);
        start.setHours(0, 0, 0, 0);
    } else start.setDate(end.getDate() - 30);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
};

export const formatRevenue = (n) =>
    (Number(n) || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
